import AWS from 'aws-sdk'

AWS.config.update({
  accessKeyId: 'AKIA4WHLBFZ3CD5PHRF4',
  secretAccessKey: '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',
  region: 'us-west-2',
})

const s3 = new AWS.S3()

export default s3
